import { useIntl } from "@/infra/locale";
import { useTreatmentSelectionStore } from "@/infra/stores/treatmentSelectionStore";
import { TextArea } from "@akina/presentation";
import { WebshopHeader } from "../layout/WebshopHeader";
import { PhysiotherapistCard } from "./PhysiotherapistCard";

const MAX_LENGTH = 1500;

export function CustomPlanView() {
  const { formatMessage } = useIntl();
  const customDescription = useTreatmentSelectionStore(s => s.customDescription);
  const setCustomDescription = useTreatmentSelectionStore(s => s.actions.setCustomDescription);

  return (
    <div className="flex flex-col gap-8">
      <WebshopHeader
        title={formatMessage({ id: "checkoutPage.resultStep.customTherapyPlan.title" })}
        subtitle={formatMessage({ id: "checkoutPage.resultStep.customTherapyPlan.subtitle" })}
      />

      <div className="overflow-hidden rounded-[32px] bg-white p-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-stretch lg:gap-8">
          <div className="flex min-w-0 flex-1 flex-col rounded-2xl bg-white">
            <TextArea
              className="font-area h-64 resize-none font-medium lg:h-100"
              placeholder={formatMessage({ id: "checkoutPage.resultStep.customTherapyPlan.textAreaPlaceholder" })}
              maxLength={MAX_LENGTH}
              value={customDescription}
              onChange={e => setCustomDescription(e.target.value)}
            />
          </div>
          <div className="flex w-full flex-col lg:w-106.75 lg:shrink-0">
            <PhysiotherapistCard />
          </div>
        </div>
      </div>
    </div>
  );
}
